import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
import { GooglePayChargeTransactionResponse } from 'vopay';

const { api } = vopayApi;

export default function useGooglePayChargeTransaction() {
  const source = axios.CancelToken.source();
  const [transaction, setTransaction] = useState<GooglePayChargeTransactionResponse>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchGooglePayChargeTransaction(transactionId: string) {
    try {
      setLoading(true);
      const res = await api.fetchGooglePayChargeTransaction({ TransactionID: transactionId }, source);
      if (!res.Success) {
        setTransaction(undefined);
        throw new Error(res.ErrorMessage);
      }
      setTransaction(res);
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    transaction,
    fetchGooglePayChargeTransaction,
  };
}
